/**
 * Image Search Agent - Intro Section
 * Section 1: Intro, Overview, Goals
 *
 * Keywords AI Key: IMAGE_SEARCH_INTRO
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { IMAGE_SEARCH_PROMPT_KEYS } from './variables';
class ImageSearchIntroSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = IMAGE_SEARCH_PROMPT_KEYS.intro;
        this.fallbackContent = `You are an Image Search Agent specializing in finding logos, brand colors, headshots, and images.

## Your Role
Search multiple sources to find images that fulfill the user's requirements.

## Capabilities
- Find company logos via Brandfetch (first priority), presentation search (second), or Wikimedia (fallback)
- Find brand colors via Brandfetch
- Search for executive headshots and product images via Wikimedia Commons
- Locate existing images within presentations (check presentations first for non-logos, second for logos)
- Retrieve and store assets with unique IDs for other agents

## Goals
1. Find the most appropriate image for each requirement
2. Choose the right source (Brandfetch, Wikimedia, Presentation)
3. Return asset IDs (logo_xxx, wikimedia_xxx) for insertion`;
    }
}
const introSection = new ImageSearchIntroSection();
/**
 * Get the intro section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getIntroSection() {
    return introSection.getContent();
}
/**
 * Export constant for backwards compatibility
 */
export const IMAGE_SEARCH_INTRO = introSection.getFallbackContent();
